import { render, staticRenderFns } from "./CredentialsList.vue?vue&type=template&id=e2bb96a2"
import script from "./CredentialsList.vue?vue&type=script&lang=js"
export * from "./CredentialsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports